import { NavLink } from 'react-router-dom';

import { 
    ChartBarIcon, 
    // ChartPieIcon 
  } from '@heroicons/react/solid';

//image
// import reportPng from '../../../../images/report.png';

const ReportHeadingOrg = () => {
  return (
    <div>
      <div>
        {/* <img 
        className="h-32 w-full object-cover lg:h-48" 
        src={reportPng}
        alt="Reports" /> */}
      </div>
      <div className="max-w-7xl mx-auto">
        <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
          <div className="mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
            <div className="mt-12 flex flex-col justify-stretch space-y-3 md:mt-12 sm:flex-row sm:space-y-0 sm:space-x-4 sm:mt-12">
              {/* <button
                type="button"
                className="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
              >
                <ChartPieIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                <span>Charts</span>
              </button> */}
              <NavLink
              style={{textDecoration: 'none'}}
              exact
              to={'/report'}
              >
                <button
                type="button"
                className="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                >
                  <ChartBarIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                  <span>User Stats</span>
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportHeadingOrg